
import state from './../../zviz2/zviz/state';
import {default as Group, Controller as GroupController} from './../../zviz2/zviz/components/group';
import Path from './../../zviz2/zviz/components/path';
import {extend} from './../../zviz2/zviz/functions';

import ThemeItem from './themeitem';

//import {LifeCycle} from './../zviz2/zviz/cycle';
import flowModel from './../../model/flow';
import config from './../../config';


class Controller extends GroupController{

    constructor(parent, blueprint={}){

        super(parent, blueprint);
        
        // this.setResponder('map.height', [this, this.updateChildren]);
        this.maxValue = 0;
        this.maxSize = 20;
        this.roomForItems = 0;
    }

    
    getChildren(){

        let result = [];
        this.maxValue = 0;
        let dimension = this.models['flow'].dimensionTheme;

        let items = this.models['flow'].items;
        if(! items || !items[dimension]){
            return [];
        }
        let margin = (state.get('renderSize') == 'small')? 0: 80;
        let width = this.getControllerByUid('svg').getWidth() - 2*margin;

        let count = (items[dimension])? items[dimension].length: 0;

        let mapHeight = this.getControllerByUid('svg').getHeight(true);

        for(let dim of Object.keys(items)){

            let i = 0;
            let split = count;
            let position = 'top';
            if(count > 8){
                split = Math.ceil(count/2);
            }
            this.roomForItems = width/split;
            for(let item of items[dimension]){
                if(item.amount > this.maxValue){
                    this.maxValue = item.amount;
                }

                if(dim == dimension){
                    
                    let xO = i;
                    if(position != 'top'){
                        xO -= Math.ceil(count/2);
                    }

                    let x = (xO+0.5) * (width / split);

                    let y = 0;
                    if(position == 'top'){
                        y = (config.display.mapOffset.top - 60) + width*(0.35 * Math.pow((x - 0.5*width)/width, 2));
                    }else{
                        y = mapHeight + 60 - (config.display.mapOffset.bottom - 0.5*this.maxSize) - width*(0.35 * Math.pow((x - 0.5*width)/width, 2));
                    }

                    if(xO == 0){
                        let x1 = margin;
                        let x2 = margin+width;
                        let o = width * 0.35 * 0.25;
                        let y1 = 0;
                        let y2 = 0;
                        if(position == 'top'){
                            y1 = (config.display.mapOffset.top - 60) + o 
                            y2 = y1 - 2*o;
                        }else{
                            y1 = mapHeight + 60 - (config.display.mapOffset.bottom - 0.5*this.maxSize) - o;
                            y2 = y1 + 2*o;
                        }
                        // draw line
                        result.push(extend({
                            uid: '_tpt'+position,
                            properties: {
                                attributes: {
                                    'd': 'M' +x1 + ','+y1 + ' Q' + (0.5*(x2+x1)) + ',' + y2 + ' ' + x2 + ',' + y1 
                                },
                                style: {
                                    fill: 'none',
                                    strokeWidth: '1px',
                                    stroke: '#cccccc'
                                }
                            }
                        }, Path));
                    }

                    result.push(extend({
                        uid: '_ti_' + dim + item.value,
                        properties: {
                            data: {
                                dim: dim,
                                name: item.value,
                                amount: item.amount,
                                coords: [margin + x, y],
                                position: position
                            }
                        }
                    }, ThemeItem));

                    i++;
                    if(i >= split){
                        split = Math.floor(count / 2);
                        position = 'bottom';
                    }

                }
            }

        }



        return result;

    }


} 


let Blueprint = extend({
    type: Controller,
    models: {
        'flow': null
    },
    listeners: [
        (ctrl) => (ctrl.addListener(ctrl.models['flow'], [ctrl, ctrl.update]))
    ],
    properties: {
        attributes: {
            // transform: 'translate(0,-'+config.display.mapOffset.top+')'
        }
    },
    children: [
       (ctrl) => ( ctrl.getChildren() )
    ]
}, Group);


export default Blueprint;
export {Controller, Blueprint};

